import { push } from "connected-react-router";
import RouteEnum from "constants/RouteEnum";
import { store } from "index";
import NavigationStateModel from "stores/shared/models/NavigationStateModel";
import FormatUtility from "./FormatUtility";

export default class NavigationUtility {
    public static redirectToPage = (page: string) => {
        store.dispatch(
            push(
                page,
                new NavigationStateModel({
                    reload: true,
                })
            )
        );
    };

    public static redirectToPageWithParams = (page: string, stringParams: string) => {
        console.log("stringParams:" + stringParams);
        store.dispatch(
            push(
                page + "?" + stringParams,
                new NavigationStateModel({
                    reload: true,
                })
            )
        );
    };

    public static redirectToPageWithState = (page: string, state: any) => {
        store.dispatch(push(page, state));
    };

    public static checkIfIsCurrentPage = (pathname: string, paths: string | string[] | RouteEnum | RouteEnum[]) => {
        let pathsref = [] as string[];
        if (Array.isArray(paths) === true) {
            pathsref = paths as string[];
        } else {
            pathsref = [paths as string];
        }
        return pathsref
            .map((elem) => {
                return FormatUtility.getPath(pathname) === FormatUtility.getPath(elem);
            })
            .some((result) => result === true);
    };

    public static checkIfIsSidePage = (pathname: string): boolean => {
        if (NavigationUtility.checkIfIsCurrentPage(pathname, [RouteEnum.ACCESSO])) {
            return true;
        } else {
            return false;
        }
    };
}
